module.exports = __webpack_public_path__ + "assets/img/naver_768.0ec247f8.png";